/* ============================================================
   JMD Produktside · Lysskinne Krog (lys26) — klient-adfærd

   1) Sæson-skifter (auto efter måned + manuelle faner)
   2) Skitse-toggle
   3) Proxy-knapper (pakke/farve) → temaets rigtige variant-radios
   4) Pris-spejle: "pr. krog", pakke-label, hurtig-køb-total
   5) Sticky bar: qty-spejl, knap-total, reveal
   6) Quote-væg fra ÆGTE Judge.me-anmeldelser
   7) Judge.me-widget flyttes ind i anmeldelses-sektionen

   Kører OVEN PÅ temaets motorer (theme.js variant-engine, main-product.js
   PdStickyBar, buy-buttons' refreshButton) — ændrer dem ikke.
   ============================================================ */
(function () {
  'use strict';

  var section = document.querySelector('.lys26');
  if (!section) return;

  var sectionId = section.getAttribute('data-section');

  /* ── 1) Sæson-skifter ──
     Liquid har allerede valgt en sæson server-side, men Shopifys full-page
     cache kan servere et gammelt 'now'. Vi genberegner derfor klient-side
     og retter kun hvis resultatet afviger. Manuelle klik vinder altid. */
  (function initSeasons() {
    var tabWrap = section.querySelector('[data-lys-season-tabs]');
    if (!tabWrap) return;

    var tabs = Array.prototype.slice.call(tabWrap.querySelectorAll('[data-lys-season]'));
    if (!tabs.length) return;

    var scene = section.querySelector('[data-lys-scene]');
    var wash = section.querySelector('[data-lys-scene-wash]');
    var label = section.querySelector('[data-lys-season-label]');

    function activate(key) {
      var match = tabs.filter(function (t) { return t.getAttribute('data-lys-season') === key; })[0];
      if (!match) return;

      tabs.forEach(function (t) {
        var on = t === match;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });

      section.querySelectorAll('[data-lys-season-photo]').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-lys-season-photo') === key);
      });
      section.querySelectorAll('[data-lys-season-orns]').forEach(function (o) {
        o.hidden = o.getAttribute('data-lys-season-orns') !== key;
      });
      section.querySelectorAll('[data-lys-season-note]').forEach(function (n) {
        n.classList.toggle('is-active', n.getAttribute('data-lys-season-note') === key);
      });

      if (label) label.textContent = match.getAttribute('data-period') || '';
      if (scene && match.getAttribute('data-bg')) scene.style.background = match.getAttribute('data-bg');
      if (wash && match.getAttribute('data-wash')) wash.style.background = match.getAttribute('data-wash');
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { activate(t.getAttribute('data-lys-season')); });
    });

    /* Auto-korrektion efter klientens dato: Liquid har allerede valgt en
       sæson, men et cachet svar kan være fra sidste måned. */
    var mapAttr = section.getAttribute('data-season-map') || '';
    var map = mapAttr.split(',').map(function (s) { return s.trim().toLowerCase(); });
    if (map.length === 12) {
      var want = map[new Date().getMonth()];
      var server = (section.getAttribute('data-auto-season') || '').toLowerCase();
      if (want && want !== server) activate(want);
    }
  })();

  /* ── 2) Skitse-toggle ── */
  (function initSketch() {
    var btn = section.querySelector('[data-lys-sketch-toggle]');
    var sketch = section.querySelector('[data-lys-sketch]');
    if (!btn || !sketch) return;

    btn.addEventListener('click', function () {
      var off = sketch.classList.toggle('is-off');
      btn.textContent = off
        ? (btn.getAttribute('data-label-show') || 'Vis skitse')
        : (btn.getAttribute('data-label-hide') || 'Skjul skitse');
    });
  })();

  /* ── 3) Proxy-knapper → temaets rigtige variant-radios ──
     Designets pakke-/farvekort er ikke selv formularfelter. De checker den
     tilsvarende radio i <variant-radios-detail> og dispatcher et boblende
     change — præcis som PdStickyBar.onVariantClick gør. Derefter overtager
     theme.js: pris, form-input, sticky bar og URL opdateres af motoren. */
  /* Pickeren slås op FRISK hver gang. Temaet kan gen-rendere
     <variant-radios-detail> under opstart (skeleton/variant-motor), og en
     cachet reference ville så pege på en løsrevet node med frosne radios. */
  function getPicker() {
    return section.querySelector('variant-radios-detail, variant-group-detail');
  }

  /* Ønsket valg pr. option-position, sat af proxy-knapperne.
     Temaets motor gen-renderer pickeren ~2 sekunder efter et klik, og indtil
     da rapporterer radioerne stadig den GAMLE værdi. Uden dette ville pris
     pr. krog og labels halte to sekunder efter knappen. Et ønske ryddes så
     snart radioerne er enige — eller efter 4 s, så et mislykket skift ikke
     kan låse visningen fast. */
  var desired = {};
  function setDesired(position, value) {
    desired[position] = value;
    setTimeout(function () {
      if (desired[position] === value) delete desired[position];
    }, 4000);
  }

  function fieldsetFor(position) {
    var picker = getPicker();
    if (!picker) return null;
    var fieldsets = picker.querySelectorAll('fieldset');
    return fieldsets[parseInt(position, 10) - 1] || null;
  }

  (function initProxies() {
    section.querySelectorAll('[data-lys-proxy-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var pos = btn.getAttribute('data-lys-proxy-position');
        var val = btn.getAttribute('data-lys-proxy-value');
        var fs = fieldsetFor(pos);
        if (!fs) return;

        var radios = fs.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].value === val) {
            if (radios[i].checked) return;
            setDesired(pos, val);
            radios[i].checked = true;
            radios[i].dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
        }
      });
    });

    /* Aktiv-tilstand følger det ønskede valg hvis der er et (proxy-klik lige
       nu), ellers den faktiske radio-tilstand — så sticky-bar-pills og
       ?variant= i URL'en også slår igennem. */
    function valueFor(position) {
      if (desired[position] !== undefined) return desired[position];
      var fs = fieldsetFor(position);
      if (!fs) return null;
      var checked = fs.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : null;
    }

    function syncProxyState() {
      /* Ryd ønsker som radioerne nu er enige om, så senere skift fra
         sticky-baren ikke bliver overskrevet af et forældet ønske. */
      Object.keys(desired).forEach(function (pos) {
        var fs = fieldsetFor(pos);
        if (!fs) return;
        var checked = fs.querySelector('input[type="radio"]:checked');
        if (checked && checked.value === desired[pos]) delete desired[pos];
      });

      section.querySelectorAll('[data-lys-proxy-value]').forEach(function (btn) {
        var val = valueFor(btn.getAttribute('data-lys-proxy-position'));
        btn.classList.toggle('is-active', val !== null && val === btn.getAttribute('data-lys-proxy-value'));
      });

      /* "Valgt: X"-labels + live-specrækker */
      section.querySelectorAll('[data-lys-picked]').forEach(function (span) {
        var val = valueFor(span.getAttribute('data-lys-picked'));
        if (val !== null) span.textContent = val;
      });
    }

    /* Temaets motor kan nå at gen-rendere pickeren efter vores change —
       kør derfor et par gange mere, så tilstanden konvergerer. */
    function syncSoon() {
      syncProxyState();
      setTimeout(syncProxyState, 150);
      setTimeout(syncProxyState, 450);
    }

    section.addEventListener('change', syncSoon);
    document.addEventListener('variant-change', syncSoon);
    syncSoon();
  })();

  /* ── 4) Pris-spejle ──
     Variantens pris ejes af temaet (#price-{sectionId}). Herfra afledes:
       · "X,XX kr pr. krog"  (variantpris ÷ antal i pakkenavnet, fx "10 stk")
       · pakke-label i priskortet og hurtig-køb
       · hurtig-køb-knappens total (spejler hovedknappens .btn-price) */
  (function initPriceMirrors() {
    var productData = null;

    function getProduct() {
      if (productData) return productData;
      var el = section.querySelector('[data-product-json], .productJson');
      if (!el) return null;
      try { productData = JSON.parse(el.textContent); } catch (e) { return null; }
      return productData;
    }

    /* Varianten udledes af de CHECKEDE radios, ikke af formularens skjulte
       input. Temaets motor skriver først det skjulte input asynkront efter
       change-eventet, så et input-opslag her ville læse den FORRIGE variant
       (race → priser og labels frøs på den gamle pakke). Radiotilstanden er
       derimod sat synkront af proxy-knappen. Inputtet er fallback. */
    function currentVariant() {
      var data = getProduct();
      if (!data || !data.variants) return null;

      var picker = getPicker();
      if (picker) {
        var fieldsets = picker.querySelectorAll('fieldset');
        var chosen = [];
        for (var i = 0; i < fieldsets.length; i++) {
          /* Ønsket valg vinder over radioen indtil temaet er færdig med
             sin gen-rendering (se setDesired) — ellers halter visningen. */
          var want = desired[String(i + 1)];
          if (want !== undefined) { chosen.push(want); continue; }
          var checked = fieldsets[i].querySelector('input[type="radio"]:checked');
          if (!checked) { chosen = null; break; }
          chosen.push(checked.value);
        }
        if (chosen && chosen.length) {
          for (var j = 0; j < data.variants.length; j++) {
            var v = data.variants[j];
            var match = true;
            for (var k = 0; k < chosen.length; k++) {
              if (v['option' + (k + 1)] !== chosen[k]) { match = false; break; }
            }
            if (match) return v;
          }
        }
      }

      var input = section.querySelector('form[id^="product-form-"] input[name="id"]');
      if (!input) return null;
      var id = parseInt(input.value, 10);
      for (var m = 0; m < data.variants.length; m++) {
        if (data.variants[m].id === id) return data.variants[m];
      }
      return null;
    }

    function money(cents) {
      var v = (cents / 100).toFixed(2).replace('.', ',');
      return v + ' kr';
    }

    /* Antal kroge udledes af pakke-optionens værdi ("10 stk" → 10). */
    function packCount(variant) {
      if (!variant) return 0;
      for (var i = 1; i <= 3; i++) {
        var raw = variant['option' + i];
        if (!raw) continue;
        var m = String(raw).match(/^\s*(\d+)\s*stk/i);
        if (m) return parseInt(m[1], 10);
      }
      return 0;
    }

    function update() {
      var variant = currentVariant();
      if (!variant) return;

      var n = packCount(variant);
      section.querySelectorAll('[data-lys-each]').forEach(function (el) {
        el.textContent = n > 0 ? money(variant.price / n) + ' pr. krog' : '';
      });

      var label = (variant.title || '').split(' / ').join(' · ');
      section.querySelectorAll('[data-lys-pack-label]').forEach(function (el) {
        el.textContent = label + ' · inkl. moms';
      });

      section.querySelectorAll('[data-lys-price-mirror]').forEach(function (el) {
        el.textContent = money(variant.price);
      });

      section.querySelectorAll('[data-lys-sticky-variant]').forEach(function (el) {
        el.textContent = label;
      });

      /* hurtig-køb-total følger hovedknappen (som allerede regner mængde ind) */
      var mainPrice = section.querySelector('.product-form__submit .btn-price');
      section.querySelectorAll('[data-lys-total]').forEach(function (el) {
        el.textContent = mainPrice && mainPrice.textContent.trim()
          ? mainPrice.textContent.trim()
          : money(variant.price);
      });

      /* udsolgt-tilstand spejles til hurtig-køb-knappen */
      var mainBtn = section.querySelector('.product-form__submit');
      section.querySelectorAll('[data-lys-quick-add]').forEach(function (el) {
        el.disabled = !!(mainBtn && mainBtn.disabled);
      });
    }

    /* Kør flere gange efter et skift: temaets motor arbejder asynkront
       (og kan gen-rendere pickeren), så én måling lige efter eventet er
       ikke nok til at ramme sluttilstanden. */
    var timers = [];
    function debounced() {
      timers.forEach(clearTimeout);
      timers = [60, 200, 500].map(function (ms) { return setTimeout(update, ms); });
    }

    section.addEventListener('change', debounced);
    document.addEventListener('variant-change', debounced);

    var mainForm = section.querySelector('form[id^="product-form-"]');
    if (mainForm) {
      new MutationObserver(debounced).observe(mainForm, {
        childList: true, characterData: true, subtree: true
      });
    }
    update();
  })();

  /* ── 5) Sticky bar: qty-spejl + total + reveal ──
     Samme kontrakt som pv26: den skjulte quantity-input i sticky-formularen
     holdes synkron med hovedformularens quantity-input, og knap-teksten
     læser hovedknappens .btn-price LIVE (noden udskiftes ved variantskift —
     caches den, fryser totalen). */
  (function initSticky() {
    var sticky = section.querySelector('pd-sticky-bar');
    if (!sticky) return;

    var mainQty = section.querySelector('quantity-input input[name="quantity"]');
    var stickyQtyInput = sticky.querySelector('[data-lys-sticky-quantity]');
    var stickyQtyValue = sticky.querySelector('[data-lys-qty-value]');
    var minusBtn = sticky.querySelector('[data-lys-qty-minus]');
    var plusBtn = sticky.querySelector('[data-lys-qty-plus]');
    var btnText = sticky.querySelector('.pd-sticky__btn-text');
    var stickyBtn = sticky.querySelector('.pd-sticky__btn');

    function mainBtnPrice() { return section.querySelector('.product-form__submit .btn-price'); }

    function currentQty() {
      var raw = mainQty ? mainQty.value : (stickyQtyInput && stickyQtyInput.value);
      var v = parseInt(raw, 10);
      return isNaN(v) || v < 1 ? 1 : Math.min(v, 99);
    }

    function syncBtnText() {
      if (!btnText || !stickyBtn || stickyBtn.disabled) return;
      var p = mainBtnPrice();
      if (p && p.textContent.trim()) btnText.textContent = 'Læg i kurv · ' + p.textContent.trim();
    }

    function syncFromMain() {
      var q = currentQty();
      if (stickyQtyValue) stickyQtyValue.textContent = String(q);
      if (stickyQtyInput) stickyQtyInput.value = String(q);
      syncBtnText();
    }

    function setQty(q) {
      q = Math.max(1, Math.min(99, q));
      if (mainQty) {
        mainQty.value = String(q);
        /* input + change → buy-buttons' refreshButton genberegner totalen */
        mainQty.dispatchEvent(new Event('input', { bubbles: true }));
        mainQty.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (stickyQtyInput) stickyQtyInput.value = String(q);
      if (stickyQtyValue) stickyQtyValue.textContent = String(q);
      syncBtnText();
    }

    if (minusBtn) minusBtn.addEventListener('click', function () { setQty(currentQty() - 1); });
    if (plusBtn) plusBtn.addEventListener('click', function () { setQty(currentQty() + 1); });
    if (mainQty) {
      mainQty.addEventListener('input', syncFromMain);
      mainQty.addEventListener('change', syncFromMain);
    }

    var mainForm = section.querySelector('form[id^="product-form-"]');
    if (mainForm) {
      new MutationObserver(syncBtnText).observe(mainForm, {
        childList: true, characterData: true, subtree: true
      });
    }

    /* PdStickyBar overskriver knap-teksten ved variantskift — sync bagefter.
       Guard mod observer-loop: kun når teksten IKKE allerede har en total. */
    if (btnText) {
      new MutationObserver(function () {
        if ((btnText.textContent || '').indexOf('·') === -1 && stickyBtn && !stickyBtn.disabled) {
          syncBtnText();
        }
      }).observe(btnText, { childList: true, characterData: true, subtree: true });
    }

    document.addEventListener('variant-change', syncBtnText);
    syncFromMain();

    /* reveal: vis baren når priskortet er ude af viewport (begge retninger —
       på mobil ligger kortet under folden ved load) */
    var priceCard = section.querySelector('.lys26-pricecard');
    function show(v) { sticky.classList.toggle('pv26-sticky-visible', v); }

    if (priceCard && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { show(!e.isIntersecting); });
      }, { threshold: 0 }).observe(priceCard);
    } else {
      window.addEventListener('scroll', function () { show(window.scrollY > 700); }, { passive: true });
    }
  })();

  /* ── 6) Quote-væg fra ÆGTE Judge.me-anmeldelser ──
     Understøtter Widget V3 (.jm-*) og legacy (.jdgm-*). Ingen kuraterede
     fallbacks: er der ingen brugbare anmeldelser, forbliver væggen skjult. */
  (function initQuoteWall() {
    var wall = section.querySelector('[data-lys-quote-wall]');
    if (!wall) return;

    var maxQuotes = parseInt(wall.getAttribute('data-max-quotes'), 10) || 4;
    var done = false;

    function scoreOf(rev) {
      var v3 = rev.querySelector('.jm-star-rating');
      if (v3) {
        var m = (v3.getAttribute('aria-label') || '').match(/([\d.,]+)\s*out of/);
        if (m) return parseFloat(m[1].replace(',', '.')) || 0;
      }
      var r = rev.querySelector('.jdgm-rev__rating');
      if (r && r.getAttribute('data-score')) return parseFloat(r.getAttribute('data-score')) || 0;
      return rev.querySelectorAll('.jdgm-star.jdgm--on').length;
    }

    function textOf(rev, sel) {
      var el = rev.querySelector(sel);
      return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : '';
    }

    function truncate(s, n) {
      if (s.length <= n) return s;
      return s.slice(0, n - 1).replace(/\s+\S*$/, '') + '…';
    }

    function collect() {
      var out = [];
      document.querySelectorAll('.jm-review-item, .jdgm-rev').forEach(function (rev) {
        var body = textOf(rev, '.jm-review-content__body, .jdgm-rev__body');
        if (!body) body = textOf(rev, '.jm-review-content__title');
        if (scoreOf(rev) >= 4.5 && body.length >= 20) {
          out.push({ body: body, author: textOf(rev, '.jm-reviewer-info__name, .jdgm-rev__author') });
        }
      });
      return out;
    }

    function hydrate() {
      if (done) return;
      var reviews = collect();
      if (!reviews.length) return;
      done = true;

      var frag = document.createDocumentFragment();
      reviews.slice(0, maxQuotes).forEach(function (r) {
        var card = document.createElement('div');
        card.className = 'lys26-quote';

        var stars = document.createElement('span');
        stars.className = 'lys26-stars';
        stars.setAttribute('aria-hidden', 'true');
        stars.textContent = '★★★★★';

        var p = document.createElement('p');
        p.textContent = truncate(r.body, 180);

        var who = document.createElement('span');
        who.className = 'lys26-quote-author';
        who.textContent = r.author || 'Verificeret køb';
        var verified = document.createElement('span');
        verified.className = 'lys26-quote-verified';
        verified.textContent = ' · verificeret køb';
        who.appendChild(verified);

        card.appendChild(stars);
        card.appendChild(p);
        card.appendChild(who);
        frag.appendChild(card);
      });

      wall.innerHTML = '';
      wall.appendChild(frag);
      wall.hidden = false;
    }

    var tries = 0;
    var iv = setInterval(function () {
      hydrate();
      if (done || ++tries > 20) clearInterval(iv);
    }, 700);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hydrate);
    } else {
      hydrate();
    }

    var obs = new MutationObserver(function () {
      hydrate();
      if (done) obs.disconnect();
    });
    obs.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 16000);
  })();

  /* ── 7) Flyt Judge.me-widget'en ind i anmeldelses-sektionen ──
     Widget'en renderes af apps-sektionen ([id$="__apps_judgeme_v2"]), der er
     skjult via CSS. Samme mønster som pv26's v2MoveReviews. */
  (function moveReviews() {
    var target = section.querySelector('[data-lys-reviews-target]');
    if (!target) return;
    var moved = false;

    function attempt() {
      if (moved) return true;
      var appsSection = document.querySelector('[id$="__apps_judgeme_v2"]');
      if (!appsSection) return false;
      var widget = appsSection.querySelector('.jdgm-review-widget, .jm-review-widget');
      if (!widget) return false;
      var ready = widget.classList.contains('jdgm--done-setup-widget') || widget.innerHTML.length > 50;
      if (!ready) return false;
      target.appendChild(widget);
      moved = true;
      return true;
    }

    setTimeout(attempt, 500);
    setTimeout(attempt, 2000);
    setTimeout(attempt, 5000);

    var obs = new MutationObserver(function () { if (attempt()) obs.disconnect(); });
    function startObserving() {
      var appsSection = document.querySelector('[id$="__apps_judgeme_v2"]');
      if (appsSection) {
        obs.observe(appsSection, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      } else {
        setTimeout(startObserving, 500);
      }
    }
    startObserving();
    setTimeout(function () { obs.disconnect(); }, 20000);
  })();
})();
